webpackJsonp([193747675109532],{

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fa = __webpack_require__(128);
	
	var _tim = __webpack_require__(348);
	
	var _tim2 = _interopRequireDefault(_tim);
	
	var _david = __webpack_require__(347);
	
	var _david2 = _interopRequireDefault(_david);
	
	var _adam = __webpack_require__(346);
	
	var _adam2 = _interopRequireDefault(_adam);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PeopleAbout = function PeopleAbout() {
	    return _react2.default.createElement(
	        'section',
	        { className: 'peopleAbout' },
	        _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement(
	                'h1',
	                { className: 'title' },
	                'Our People'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'Our team is made up of creative and technical experts alike, all working together to achieve the goals of our clients. Meet the people involved who make it all happen.'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'peopleAbout__grid' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'peopleAbout__grid__person' },
	                    _react2.default.createElement('img', { src: _tim2.default, alt: 'employee' }),
	                    _react2.default.createElement(
	                        'h3',
	                        { className: 'subtitle' },
	                        'Timothy Hunt, BA Hons'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Creative Director'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'peopleAbout__grid__person__social' },
	                        _react2.default.createElement(_fa.FaLinkedin, null),
	                        _react2.default.createElement(_fa.FaDribbble, null),
	                        _react2.default.createElement(_fa.FaTwitter, null)
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'peopleAbout__grid__person' },
	                    _react2.default.createElement('img', { src: _david2.default, alt: 'employee' }),
	                    _react2.default.createElement(
	                        'h3',
	                        { className: 'subtitle' },
	                        'David Hamilton, PhD'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Technical Director'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'peopleAbout__grid__person__social' },
	                        _react2.default.createElement(_fa.FaLinkedin, null),
	                        _react2.default.createElement(_fa.FaDribbble, null)
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'peopleAbout__grid__person' },
	                    _react2.default.createElement('img', { src: _adam2.default, alt: 'employee' }),
	                    _react2.default.createElement(
	                        'h3',
	                        { className: 'subtitle' },
	                        'Adam Pugh, BA Hons'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Frontend Developer'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'peopleAbout__grid__person__social' },
	                        _react2.default.createElement(_fa.FaLinkedin, null),
	                        _react2.default.createElement(_fa.FaDribbble, null),
	                        _react2.default.createElement(_fa.FaTwitter, null)
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'svg',
	            { className: 'peopleAbout__wavyDiv', id: '', 'data-name': 'Layer 1', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 1416.99 174.01' },
	            _react2.default.createElement('defs', null),
	            _react2.default.createElement('title', null),
	            _react2.default.createElement('path', { className: 'cls-1', d: 'M0,280.8S283.66,59,608.94,163.56s437.93,150.57,808,10.34V309.54H0V280.8Z',
	                transform: 'translate(0 -135.53)' })
	        )
	    );
	};
	
	exports.default = PeopleAbout;
	module.exports = exports['default'];

/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PeopleHero = function PeopleHero() {
	    return _react2.default.createElement(
	        "section",
	        { className: "peopleHero" },
	        _react2.default.createElement(
	            "svg",
	            { className: "peopleHero__wavyDiv", id: "", "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 1416.99 174.01" },
	            _react2.default.createElement("defs", null),
	            _react2.default.createElement("title", null),
	            _react2.default.createElement("path", { className: "cls-1", d: "M0,280.8S283.66,59,608.94,163.56s437.93,150.57,808,10.34V309.54H0V280.8Z",
	                transform: "translate(0 -135.53)" })
	        )
	    );
	};
	
	exports.default = PeopleHero;
	module.exports = exports["default"];

/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Layout = __webpack_require__(14);
	
	var _Layout2 = _interopRequireDefault(_Layout);
	
	var _Navbar = __webpack_require__(17);
	
	var _Navbar2 = _interopRequireDefault(_Navbar);
	
	var _PeopleHero = __webpack_require__(150);
	
	var _PeopleHero2 = _interopRequireDefault(_PeopleHero);
	
	var _PeopleAbout = __webpack_require__(149);
	
	var _PeopleAbout2 = _interopRequireDefault(_PeopleAbout);
	
	var _ContactBox = __webpack_require__(15);
	
	var _ContactBox2 = _interopRequireDefault(_ContactBox);
	
	var _Footer = __webpack_require__(16);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var About = function About() {
	    return _react2.default.createElement(
	        _Layout2.default,
	        null,
	        _react2.default.createElement(_Navbar2.default, null),
	        _react2.default.createElement(_PeopleHero2.default, null),
	        _react2.default.createElement(_PeopleAbout2.default, null),
	        _react2.default.createElement(_ContactBox2.default, null),
	        _react2.default.createElement(_Footer2.default, null)
	    );
	};
	
	exports.default = About;
	module.exports = exports['default'];

/***/ }),

/***/ 346:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/adam.3d5aea64.jpg";

/***/ }),

/***/ 347:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/david.2ffec07c.jpg";

/***/ }),

/***/ 348:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/tim.000e865a.jpg";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-people-js-afc0806693dd084a35d1.js